<template>
  <div class="id_card_wrap" >
    <div class="id_card_form" >
      <div class="id_card_form_item" >
        <div class="form_item_label" >姓名：</div>
        <van-field placeholder="请输入您的姓名" class="form_input" />
      </div>

      <div class="id_card_form_item" >
        <div class="form_item_label" >身份证：</div>
        <van-field placeholder="请输入您的身份证号" class="form_input" />
      </div>
    </div>

    <div class="block" ></div>

    <div class="id_card_front" ></div>
    <div class="id_card_side" ></div>
    <van-button class="commit" >提交审核</van-button>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
export default {
  name: 'setIdCard',
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
